var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingPropBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_186_xA0_Image_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M250,211.5c-21.263,0-38.5,17.237-38.5,38.5c0,21.263,17.237,38.5,38.5,38.5 c21.263,0,38.5-17.237,38.5-38.5C288.5,228.737,271.263,211.5,250,211.5z M250,265.834c-8.745,0-15.834-7.089-15.834-15.834 c0-8.745,7.089-15.834,15.834-15.834c8.745,0,15.834,7.089,15.834,15.834C265.834,258.745,258.745,265.834,250,265.834z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M250,183.666c-36.635,0-66.334,29.699-66.334,66.334c0,36.635,29.699,66.334,66.334,66.334 c36.635,0,66.334-29.699,66.334-66.334C316.334,213.365,286.635,183.666,250,183.666z M250,309.167 c-32.677,0-59.167-26.49-59.167-59.167c0-32.677,26.49-59.167,59.167-59.167c32.677,0,59.167,26.49,59.167,59.167 C309.167,282.677,282.677,309.167,250,309.167z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M250.667,316.334c0,0-12,4.499-8.667,14.166s45.833,76.332,44,107.166s-20.5,41.416-41.417,41.416 s-110.75-16.749-110.75-145.416c0-41.666,18.536-72.306,25.5-81.333c9-11.667,27.32-22.482,28.333-25.072l2.667,1.406 c0,0-18.667,71.667,56.667,83.667L250.667,316.334z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M191.879,218.008c0,0,2.157-13.739-7.882-15.686c-10.038-1.947-89.022,1.526-114.809-15.478 s-25.617-38.461-15.159-56.576c10.459-18.114,69.881-87.538,181.31-23.204c36.084,20.833,53.351,52.206,57.687,62.75 c5.604,13.628,5.81,34.901,7.547,37.073l-2.552,1.607c0,0-52.731-51.999-100.79,7.242L191.879,218.008z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M306.5,215.23c0,0,10.799,8.669,17.504,0.949s43.189-77.859,70.809-91.688 c27.619-13.83,46.117-2.955,56.576,15.159c10.457,18.115,40.869,104.288-70.561,168.621c-36.084,20.833-71.887,20.1-83.186,18.583 c-14.604-1.962-33.131-12.419-35.88-12.001l-0.116-3.014c0,0,71.398-19.667,44.124-90.907L306.5,215.23z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M286.058,203.09c0,0,2.808,5.16,0,6.41s-14.808,5.25-14.808,5.25s-3.046,1.071-5.754,0l-4.996,8.127 L275.75,244h11.556c0,0-0.056-3,1.194-4.5s7.5-8.5,7.5-8.5s5.92-4.881,10.169,0.364l3.581-2.614l-9.178-17.25l-11.315-10.046 L286.058,203.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M273.17,304.457c0,0-6.19,0.377-6.412-3.479c-0.177-3.068,2.857-15.449,2.857-15.449 s0.595-3.173,2.877-4.983l-4.541-8.39l-25.918,2.646l-5.777,10.008c0,0,2.625,1.451,3.3,3.283c0.674,1.833,3.61,10.746,3.61,10.746 s0.667,7.329-6.784,8.754l1.858,4.279l19.527,0.676l14.358-4.775L273.17,304.457z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M191.635,241.729c0,0,3.065-5.012,5.551-3.205c2.486,1.806,11.951,10.199,11.951,10.199 s2.449,2.102,2.877,4.983l9.536,0.262l10.667-23.768l-5.777-10.007c0,0-2.569,1.548-4.494,1.216 c-1.924-0.333-11.111-2.247-11.111-2.247s-7.188-2.686-4.769-8.988l-4.056-1.794l-10.349,16.573l-3.044,14.822L191.635,241.729z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "250.046,261.5 246,267 253.938,267  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "255.956,259.892 255.202,266.678 262.077,262.709  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "260.271,255.543 263.011,261.797 266.979,254.923  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "261.833,249.621 267.333,253.667 267.333,245.729  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "260.225,243.71 267.011,244.464 263.042,237.59  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "255.877,239.396 262.131,236.656 255.257,232.687  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "249.954,237.834 254,232.334 246.062,232.334  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "244.044,239.442 244.798,232.656 237.923,236.625  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "239.729,243.79 236.989,237.536 233.021,244.411  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "238.167,249.713 232.667,245.667 232.667,253.604  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "239.775,255.623 232.989,254.869 236.958,261.743  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "244.123,259.938 237.869,262.678 244.743,266.646  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingPropBlack);
export default __webpack_public_path__ + "static/media/loading-prop-black.00f6108f551f68685be134792c77e21e.svg";
export { ForwardRef as ReactComponent };